import { useDeleteMutation, WorkspaceRoutine } from '@gripp/shared-logic';
import { Colors, CustomAlert } from '@gripp/shared-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Button } from 'react-native-paper';

type DeleteRoutineMenuItemProps = {
  onSelected: () => void;
  workspaceRoutine: WorkspaceRoutine;
};

export const DeleteRoutineButton = (props: DeleteRoutineMenuItemProps) => {
  const { t } = useTranslation();
  const [showAlert, setShowAlert] = useState(false);
  const { mutate } = useDeleteMutation({
    modelName: 'WorkspaceRoutine',
    query: DELETE_ROUTINE,
  });

  const onButtonPress = () => {
    setShowAlert(true);
  };

  const onDelete = () => {
    mutate({ input: { id: props.workspaceRoutine.id } });
    props.onSelected();
  };

  return (
    <View>
      <Button
        mode="text"
        style={{ width: 152 }}
        labelStyle={{
          fontSize: 16,
        }}
        textColor={Colors.red}
        onPress={onButtonPress}
      >
        Delete Routine
      </Button>
      <CustomAlert
        visible={showAlert}
        title={t('routines.menu.delete.title')}
        action={onDelete}
        hideAlert={() => setShowAlert(false)}
        primaryButtonLabel={t('routines.menu.delete.confirm')}
        secondaryButtonLabel={t('routines.menu.delete.cancel')}
      />
    </View>
  );
};

const DELETE_ROUTINE = `
  mutation DeleteWorkspaceRoutine($input: MutateWorkspaceRoutineInput!) {
    deleteWorkspaceRoutine(input: $input) {
      id
    }
  }
`;
